module.exports = __webpack_public_path__ + "static/banner-tablet-3d3957c16f94942de9630f3bab853550.png";